import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { track } from "@/lib/api";

const VARIANTS = {
  primary:
    "text-si-bg font-bold bg-[linear-gradient(135deg,#5fd3ff_0%,#17B6F4_45%,#176BFF_100%)] shadow-[0_10px_40px_-10px_rgba(23,182,244,0.7)] hover:brightness-110 hover:shadow-[0_14px_50px_-8px_rgba(23,182,244,0.85)]",
  secondary:
    "text-si-text font-semibold border border-si-line bg-si-surface/50 backdrop-blur-md hover:border-si-cyan/60 hover:bg-si-elev/70",
  light: "text-si-ink font-semibold border border-[#d5dcea] bg-white hover:border-si-blue/50",
  ghost: "text-si-text font-semibold px-0 hover:text-si-cyan",
};

export function Cta({ to, href, children, variant = "primary", className = "", testId, external, trackId, onClick, type, disabled, size = "md" }) {
  const sizing = variant === "ghost" ? "" : size === "lg" ? "h-14 px-7 text-base" : "h-12 px-6 text-[15px]";
  const cls = `group relative inline-flex items-center justify-center gap-2 rounded-xl ${sizing} transition-[filter,box-shadow,background-color,border-color,color,transform] duration-200 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none ${VARIANTS[variant]} ${className}`;
  const Icon = external ? ArrowUpRight : ArrowRight;
  const inner = (
    <>
      <span>{children}</span>
      <Icon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
    </>
  );
  const handle = (e) => {
    if (trackId) track(external ? "external_product_clicked" : "primary_cta_clicked", { cta: trackId });
    onClick?.(e);
  };
  if (href) {
    return (
      <a href={href} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined}
        className={cls} data-testid={testId} onClick={handle}>{inner}</a>
    );
  }
  if (to) return <Link to={to} className={cls} data-testid={testId} onClick={handle}>{inner}</Link>;
  return <button type={type || "button"} disabled={disabled} className={cls} data-testid={testId} onClick={handle}>{inner}</button>;
}
